<!-- 检索框组件   -->
<template>
  <div id="search_convas">
      <el-form
        ref="elForm"
        :model="formData"
        :rules="rules"
        size="medium"
        label-width="auto"
        style="width: 300px;"
      >
        <el-form-item label-width="0" prop="imgname" id="sbox">
          <el-input
            placeholder="图名 / 画工 / 刻工 / 来源"
            v-model="formData.imgInfo"
            class="input-with-select"
          >
            <template #append>
              <el-button
                icon="el-icon-search"
                @click="doSearch"
              ></el-button>
            </template>
          </el-input>
        </el-form-item>
      </el-form>
  </div>
</template>
<script>
import { mainTypeArray } from '@/util/typetree'
export default {
  mounted () {
    const kw = this.$store.state.globalObj.searchKeyWords
    this.formData.imgInfo = kw + '' === 'null' ? '' : kw.replace(/^\s+(.*?)\s+$/g, '$1') // 如果有参数则去除首尾空格
    this.select = this.$store.state.globalObj.searchType
  },
  data () {
    return {
      select: 'all',
      typeList: mainTypeArray,
      formData: {
        imgInfo: ''
      },
      rules: {}
    }
  },
  methods: {
    doSearch () {
      const searchType = this.select
      const imginfo = this.formData.imgInfo
      const searchWord = imginfo
      this.$store.commit('setGlobalObjOfSearchType', searchType)
      this.$store.commit('setGlobalObjOfSearchKeyWords', searchWord)
      this.$router.push('/imgList/barrel').catch(() => {})
      this.$store.commit('flipSingleBoxState')
    }
  },
  computed: {
    event3 () {
      return this.$store.state.events.searchTypeValueAndLabelState
    },
    event4 () {
      return this.$store.state.events.searchKeyValueState
    }
  },
  watch: {
    'formData.imgInfo'  (newV) {
      this.$store.commit('setGlobalObjOfSearchKeyWords', newV)
    },
    select (newV) {
      this.$store.commit('setGlobalObjOfSearchType', newV)
      // if (this.$route.path === '/imgList/barrel') { this.doSearch() }// 如果需要切换分类后自动搜索, 放开这一行即可
    },
    event3 () {
      // 添加这个监听器是为了搜索标签的时候页面不跳转, 但搜索类型不能局限
      const kType = this.$store.state.globalObj.searchType
      this.select = kType
    },
    event4 () {
      const kw = this.$store.state.globalObj.searchKeyWords
      this.formData.imgInfo = kw
    }
  }
}
</script>
<style scoped lang="less">
#rscount_div {
  width: 150px;
  display: block;
  color: #fff;
  font-size: 20px;
  float: right;

  line-height: 40px;
}
.div_blank {
  width: 2px;
}
#search_convas {
  margin-top: 0px;
  display: flex;
  justify-content: space-around;
}

#search_convas .el-select-dropdown__wrap {
  height: 330px;
  max-height: 330px;
}

#sbox :deep(.el-input__inner) {
  background-color: #fff;
  color: #000;
}
</style>
